<template>
	<div class="item margin-b-50" v-if="order.invoice">

		<div class="settings pull-right">

			<ws-dropdown>

				<template slot="thumb"><i class="fas fa-cog icon--sm dark-grey"></i></template>

				<template slot="content">

					<ul v-if="order.order_type === 'App\\Order'">
						<li><a :href="downloadURL" target="_blank"><i class="fas fa-file-pdf"></i> Hent PDF</a></li>
						<li><a :href="downloadKitchenURL" target="_blank"><i class="fas fa-utensils"></i> Hent køkken PDF</a></li>
						<li><a href="#" @click.prevent="deliver" :class="{'disabled':!canUseDeliver}" :disabled="!canUseDeliver"><i class="fas fa-truck"></i> Udlever</a></li>
						<li><a href="#" @click.prevent="resend" :class="{'disabled':!canUseResend}" :disabled="!canUseResend"><i class="fas fa-envelope"></i> Gensend ordremail</a></li>
						<li><a href="#" @click.prevent="doShowRefundModal" :class="{'disabled':!canUseRefund}" :disabled="!canUseRefund"><i class="fas fa-hand-holding-usd"></i> Refunder</a></li>
					</ul>

                    <ul v-else-if="order.order_type === 'App\\ProductlessOrder'">
                        <li><a :href="downloadProductlessUrl" target="_blank"><i class="fas fa-file-pdf"></i> Hent PDF</a></li>
                        <li><a :href="downloadProductlessKitchenUrl" target="_blank"><i class="fas fa-utensils"></i> Hent køkken PDF</a></li>
                        <li><a href="#" @click.prevent="deliver" :class="{'disabled':!canUseDeliver}" :disabled="!canUseDeliver"><i class="fas fa-truck"></i> Udlever</a></li>
                        <li><a href="#" @click.prevent="resend" :class="{'disabled':!canUseResend}" :disabled="!canUseResend"><i class="fas fa-envelope"></i> Gensend ordremail</a></li>

<!--                        <li><a href="#" @click.prevent="doShowRefundModal" :class="{'disabled':!canUseRefund}" :disabled="!canUseRefund"><i class="fas fa-hand-holding-usd"></i> Refunder</a></li> -->
                    </ul>

                    <ul v-else>
                        <li><a :href="downloadURL" target="_blank"><i class="fas fa-file-pdf"></i> Hent PDF</a></li>
                        <li><a :href="downloadKitchenURL" target="_blank"><i class="fas fa-utensils"></i> Hent køkken PDF</a></li>
                        <li><a href="#" @click.prevent="deliver" :class="{'disabled':!canUseDeliver}" :disabled="!canUseDeliver"><i class="fas fa-truck"></i> Udlever</a></li>
                        <li><a href="#" @click.prevent="resend" :class="{'disabled':!canUseResend}" :disabled="!canUseResend"><i class="fas fa-envelope"></i> Gensend ordremail</a></li>

<!--						<li><a href="#" @click.prevent="doShowRefundModal" :class="{'disabled':!canUseRefund}" :disabled="!canUseRefund"><i class="fas fa-hand-holding-usd"></i> Refunder</a></li> -->
                    </ul>

				</template>

			</ws-dropdown>

		</div>

		<h1>Ordre: {{order.id}}</h1>
        <h3 class="margin-tb-25" v-if="payedByBankTransfer"><strong>Betales via Faktura</strong></h3>

		<ul class="list">
			<template v-if="order.company_name">
				<li>Firmanavn: {{order.company_name}}</li>
				<li>CVR: {{order.cvr}}</li>
                <li v-if="order.ean">EAN: {{order.ean}}</li>
			</template>
			<li>{{order.firstname}} {{order.lastname}}</li>
			<li>{{order.email}}</li>
			<li>Tlf. {{order.phone}}</li>
		</ul>

		<p><strong>Købsdato:</strong> {{order.created_at | moment('DD MMMM YYYY [kl.] HH:mm')}}</p>
		<p v-if="order.delivered_at"><strong>Udleveret:</strong> {{order.delivered_at | moment('DD MMMM YYYY [kl.] HH:mm')}}</p>
		<p v-if="order.invoice.refunded_at"><strong>Refunderet:</strong> {{order.invoice.refunded_at | moment('DD MMMM YYYY [kl.] HH:mm')}}</p>

		<template v-if="order.with_delivery">

			<h2>Ønsker levering <span>{{stripeAmount(order.delivery_fee).amount}},-</span></h2>
			<p class="margin-b-25"><strong>Leveringsdato:</strong> {{order.deliver_at | moment('DD MMMM YYYY [kl.] HH:mm')}}</p>

			 <!--No alternative delivery address-->

			<template v-if="order.delivery_information === null">
				<ul class="list">
					<li>{{order.firstname}} {{order.lastname}}</li>
					<li>{{order.email}}</li>
					<li>Tlf. {{order.phone}}</li>
					<li>{{order.address}}</li>
					<li>{{order.zipcode}} {{order.city}}</li>
				</ul>
			</template>

			<!--Alternative Delivery address-->

			<template v-else>
				<ul class="list">
					<li>{{order.delivery_information.firstname}} {{order.delivery_information.lastname}}</li>
					<li>{{order.delivery_information.email}}</li>
					<li>{{order.delivery_information.phone}}</li>
					<li>{{order.delivery_information.address}}</li>
					<li>{{order.delivery_information.zipcode}} {{order.delivery_information.city}}</li>
				</ul>
			</template>

		</template>

		<template v-else>

			<h2>Henter selv <span>0,-</span></h2>
			<p><strong>Afhentningsdato:</strong> {{order.deliver_at | moment('DD MMMM YYYY [kl.] HH:mm')}}</p>

		</template>

		<h2>{{order.product_title}} ({{order.quantity}} stk. á {{stripeAmount(order.product_price).amount}},-) <span>{{stripeAmount(order.total_amount_without_discount_and_delivery_fee - order.total_extra_selections_amount).amount}},-</span></h2>

		<template v-for="selection in order.details.selections">
			<h3>{{selection.title}}  <span v-if="">{{stripeAmount(order.total_premium_selections_amount).amount}},-</span> </h3>
			<ul class="list">
                <template v-for="option in selection.options">
                    <li v-if="option.premium">{{option.title}} ({{order.quantity}} stk. á {{stripeAmount(option.price).amount}},-)</li>
                    <li v-else>{{option.title}}</li>
                </template>

			</ul>
		</template>

		<h2 v-if="stripeAmount(order.total_extra_selections_amount).amount > 0">Tilkøb <span>{{stripeAmount(order.total_extra_selections_amount).amount}},-</span></h2>

		<template v-for="selection in order.details.extra_selections" v-if="selection.options.length > 0">
			<h3>{{selection.title}}</h3>
			<ul class="list">
				<li v-for="option in selection.options">{{option.title}} ({{order.quantity}} stk. á {{stripeAmount(option.price).amount}},-)</li>
			</ul>
		</template>



		<h2 v-if="order.coupon_id">Rabat <template v-if="order.coupon_in_percent">{{order.coupon_value}}%</template> <span>- {{stripeAmount(order.total_discount).amount}},-</span></h2>

		<h2>Samlet pris <span>{{stripeAmount(order.total_amount).amount}},-</span></h2>

		<hr v-if="order.notes || order.delivery_notes">

		<template v-if="order.notes">
			<h2>Bemærkninger</h2>
			<p>{{order.notes}}</p>
		</template>

		<template v-if="order.delivery_notes">
			<h2>Leverings bemærkninger</h2>
			<p>{{order.delivery_notes}}</p>
		</template>


		<ws-modal v-model="showRefundModal">

			<div class="modal-wrap">

				<div class="modal--sm center">

					<span class="close" @click.prevent="showRefundModal = false"><i class="fas fa-times"></i></span>

					<i class="fas fa-hand-holding-usd icon--lg margin-b-25"></i>

					<h1>Refunder Ordre</h1>

					<h2>Er du sikker på du vil refundere ordre nummer: {{order.id}}?</h2>

					<h3>Du kan ikke fortryde denne handling!</h3>

					<div class="col-12 margin-t-25">

						<a class="btn btn--sm btn--primary primary--copper" href="#" @click.prevent="refund">Ja tak</a>

						<a href="#" @click.prevent="showRefundModal = false">Nej tak!</a>

					</div>

				</div>

			</div>

		</ws-modal>

	</div>

</template>

<script>
    export default {
        name: "order",
		data(){
          	return {
          	    fileUrl:null,
				delivering:false,
				resending:false,
				refunding:false,
				showRefundModal:false,
			}
		},
		props:['order'],
		computed:{
            delivered(){
                return this.order.delivered_at !== null;
			},
			refunded(){
                if (this.order.invoice){
                    return this.order.invoice.refund_id !== null;
                }
			},
            payedByBankTransfer(){
                if (this.order.invoice){
                    return this.order.invoice.charge_id === '##BANKTRANSFER##'
                }
            },
			canUseDeliver(){
                return !this.delivered && !this.refunded;
			},
			canUseRefund(){
                return !this.delivered && !this.refunded && !this.payedByBankTransfer;
			},
			canUseResend(){
                return !this.refunded;
			},
			downloadURL(){
                return `/admin/order/${this.order.id}/pdf`;
			},
            downloadKitchenURL(){
                return `/admin/order/${this.order.id}/kitchen/pdf`;
            },
            downloadProductlessUrl(){
                return `/admin/productless/order/${this.order.id}/pdf`;
            },
            downloadProductlessKitchenUrl(){
                return `/admin/productless/order/${this.order.id}/kitchen/pdf`;
            }
		},
		methods:{
            deliver(){
                if(this.delivering){
                    return;
                }

                if(!this.canUseDeliver){
                    return;
				}

				this.delivering = true;
                axios.post(`/api/admin/order/${this.order.id}/deliver`).then(response => {
				    this.$emit('reload');
				    this.delivering = false;
				});
			},
			resend(){
                if(this.resending){
                    return;
				}

                if(!this.canUseResend){
                    return;
                }

                this.resending = true;
                axios.post(`/api/admin/order/${this.order.id}/resend`).then(response => {
					this.resending = false;
                });
			},
			refund(){
                if(this.refunding){
                    return;
                }

                if(!this.canUseRefund){
                    return;
                }

                this.refunding = true;
                axios.delete(`/api/admin/order/${this.order.id}/refund`).then(response => {
                    this.$emit('reload');
                    this.refunding = false;
                    this.showRefundModal = false;
                });
			},
			doShowRefundModal(){
                if(this.refunding){
                    return;
                }

                if(!this.canUseRefund){
                    return;
                }

                this.showRefundModal = true;
			}
		},
		created(){
           /* axios(`/api/admin/order/${this.order.id}/pdf`,{
                method: 'GET',
                responseType: 'blob',

            }).then(response => {
                const file = new Blob(
                    [response.data],
                    {type: 'application/pdf'});
                const fileURL = URL.createObjectURL(file);
				this.fileUrl = fileURL;
            }).catch(error => {
                console.log(error);
            });*/
		}
    }
</script>

<style scoped>

</style>
